export { default as ProductView } from './ProductView';
